import { useTranslation } from 'react-i18next';
import { type Lounge, LOUNGES } from '@/constants/area';

export const MypageFacilityCard = ({
  membershipType,
}: {
  membershipType: Lounge;
}) => {
  const { t } = useTranslation();
  const isSuiteLoungeMember = membershipType === LOUNGES.SUITE_LOUNGE;

  return (
    <div className="l-lounge">
      <div className="l-lounge__desc" lang={t('common.lang')}>
        {t('myPage.info.loungeDescription1')}
      </div>
      <div className="l-lounge__logos">
        {isSuiteLoungeMember && (
          <div className="l-lounge__logo">
            <img
              className="l-lounge__logo__image l-lounge__logo__image--suite"
              src="/Common_ANASUITELOUNGE.png"
              alt="ANA SUITE LOUNGE"
            />
          </div>
        )}
        <div className="l-lounge__logo">
          <img
            className="l-lounge__logo__image l-lounge__logo__image--ana"
            src="/Common_ANALOUNGE.png"
            alt="ANA LOUNGE"
          />
        </div>
      </div>
      <div className="l-lounge__desc" lang={t('common.lang')}>
        {t('myPage.info.loungeDescription2')}
      </div>
    </div>
  );
};
